import { render } from "./병리과.vue?vue&type=template&id=0179559e"
import script from "./병리과.vue?vue&type=script&lang=js"
export * from "./병리과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__